import { NavCategory } from '@src/components/widgets/navigation/types'

export const hasLoadedMenuContent = (category: NavCategory | null): boolean =>
  Boolean(category && [category.columns, category.featured, category.spotlight].some(arr => (arr?.length ?? 0) > 0))

export const hasMenuContent = (category: NavCategory | null): boolean => {
  if (!category) {
    return false
  }
  if (category.hasSubmenu) {
    return true
  }
  return hasLoadedMenuContent(category)
}
